<template>
  <div class="spl-verify-user">
    <main-header-login />

    <div class="spl-edit-template">
      <div class="spl-edit-template__step">
        <div class="spl-h3">
          Welcome to time:matters SPLIT!
        </div>
        <div class="spl-text">
          Please enter the same email address as you received the mail to. You also need to choose a password with at least 8 characters and digits.
        </div>
        <div class="row">
          <div class="col6">
            <form-label>Email</form-label>
            <form-input
              v-model="user_model.Email"
              :required="true"
              :invalid="$v.user_model.Email.$error"
              @blur="$v.user_model.Email.$touch()" />
            <span v-if="$v.user_model.Email.$error" class="error">E-Mail is required and has to be valid.</span><br>

            <form-label>Password</form-label>
            <form-input
              v-model="user_model.Password"
              :required="true"
              :invalid="$v.user_model.Password.$error"
              type="password"
              @blur="$v.user_model.Password.$touch()" />
            <span v-if="$v.user_model.Password.$error" class="error">Password is required and has to be at least 8 characters long, including both letters and digits.</span><br>

            <form-label>Confirm Password</form-label>
            <form-input
              v-model="user_model.Password_Repeated"
              :required="true"
              :invalid="$v.user_model.Password_Repeated.$error"
              type="password"
              @blur="$v.user_model.Password_Repeated.$touch()" />
            <span v-if="$v.user_model.Password_Repeated.$error" class="error">Password confirmation needs to be the same as password.</span><br>
          </div>
        </div>
        <div class="row">
          <div class="col2">
            <form-button
              :wide="true"
              :secondary="true"
              @onClick="cancel">
              Cancel
            </form-button>
          </div>
          <div class="col2">
            <form-button :wide="true" @onClick="save">
              Save
            </form-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import webApi from '@/webApi'
import { ResetPasswordModel } from '@/webApi/DataModels'
import constants from '@/constants'
import { required, sameAs, minLength, email } from 'vuelidate/lib/validators'
const hasNumeric = (value) => {
  return /\d/g.test(value)
}
const hasAlpha = (value) => {
  return /[A-z]/g.test(value)
}

export default {
  name: 'VerifyUser',
  data () {
    return {
      user_model: {
        Email: '',
        Password: '',
        Password_Repeated: '',
        Code: ''
      }
    }
  },
  validations: {
    user_model: {
      Email: {
        required,
        email
      },
      Password: {
        required,
        minLength: minLength(8),
        hasNumeric: hasNumeric,
        hasAlpha: hasAlpha
      },
      Password_Repeated: {
        sameAsPassword: sameAs('Password')
      }
    }
  },
  created () {
    if (this.$route.query.userId && this.$route.query.userId !== '' &&
          this.$route.query.code && this.$route.query.code !== '') {
      // This is a new user, we have to first confirm the email
      this.confirm_Email()
    } else if (this.$route.query.resetCode !== '') {
      // This is a reset password => save the code
      this.user_model.Code = this.$route.query.resetCode
    } else {
      // something is wrong
      this.$router.push('./#')
    }
  },

  methods: {
    // First we want to verify the email, and if this works, we will receive a
    // reset password token we will use when the user has entered his passwords
    confirm_Email () {
      if (this.$route.query.userId !== '' && this.$route.query.code !== '') {
        webApi.account.confirm_Email(this.$route.query.userId, this.$route.query.code)
          .then((response) => {
            if (response.data as any === '') {
              window.bus.$emit('openErrorModal', 'Unfortunately we could not verify the user.')
            } else {
              this.user_model.Code = response.data
            }
          }).catch((response) => {
            window.bus.$emit('openErrorModal', 'Unfortunately we could not verify the user.')
          })
      } else {
        // No user id and/or code => goto login
        this.$router.push('./#')
      }
    },

    save () {
      var resetPasswordModel:ResetPasswordModel = this.user_model as ResetPasswordModel
      this.$v.$touch()
      if (!this.$v.$invalid) {
        webApi.account.reset_Password(resetPasswordModel)
          .then((response) => {
            if (response.data as any === '') {
              window.bus.$emit('openErrorModal', 'Unfortunately we could not verify the user.')
            } else {
              this.$toast('Your password has been set, you are ready to login!', constants.defaultToastOptions())
              this.$router.push('./#')
            }
          }).catch((response) => {
            window.bus.$emit('openErrorModal', 'Unfortunately we could not verify the user.')
          })
      }
    },

    cancel () {
      this.$router.push('./#')
    }
  }
}
</script>

<style lang="scss">
</style>
